import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface INITIALIZE_NOTIFICATIONS_PANE_FOR_ACCOUNTActionMessage {
    isOpx: boolean;
    mailboxInfo: MailboxInfo;
    callback: (() => void) | undefined;
}
const defaultExport: (
    isOpx: boolean,
    mailboxInfo: MailboxInfo,
    callback?: () => void
) => INITIALIZE_NOTIFICATIONS_PANE_FOR_ACCOUNTActionMessage = action(
    'INITIALIZE_NOTIFICATIONS_PANE_FOR_ACCOUNT',
    (
        isOpx: boolean,
        mailboxInfo: MailboxInfo,
        callback?: () => void
    ): INITIALIZE_NOTIFICATIONS_PANE_FOR_ACCOUNTActionMessage => ({
        isOpx,
        mailboxInfo,
        callback,
    })
);
export default defaultExport;
